import { Injectable, Inject } from '@angular/core';
import { STATE_MANAGEMENT_CONFIGURATION_TOKEN, states } from './tokens';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  readonly state: string;

  constructor(
    @Inject(STATE_MANAGEMENT_CONFIGURATION_TOKEN) configuration: string
  ) {
    this.state = configuration;
  }
}
